/// <reference types="vite/client" />
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

function requireEnv(key: string): string {
  const value = import.meta.env[key];
  if (typeof value !== "string" || value.length === 0) {
    throw new Error(
      `Missing required env var: ${key}. Add it to aiclotheschanger-web/.env (see .env.example).`,
    );
  }
  return value;
}

function optionalEnv(key: string): string | undefined {
  const value = import.meta.env[key];
  if (typeof value !== "string" || value.length === 0) return undefined;
  return value;
}

// authDomain must match the origin the app runs on so signInWithRedirect
// doesn't trip iOS 16.4+/17 Safari ITP storage isolation, which drops the
// credential during the OAuth roundtrip when the auth handler is on a
// third-party origin. Firebase Hosting auto-serves /__/auth/handler on
// connected custom domains, so easyclothes.net works as the authDomain in
// prod. Keep this as a configured env var (not window.location.hostname) so
// dev and prod stay decoupled.
export const resolvedAuthDomain = requireEnv("VITE_FIREBASE_AUTH_DOMAIN");

const firebaseConfig = {
  apiKey: requireEnv("VITE_FIREBASE_API_KEY"),
  authDomain: resolvedAuthDomain,
  projectId: requireEnv("VITE_FIREBASE_PROJECT_ID"),
  storageBucket: requireEnv("VITE_FIREBASE_STORAGE_BUCKET"),
  messagingSenderId: requireEnv("VITE_FIREBASE_MESSAGING_SENDER_ID"),
  // Optional today: Auth + Storage work without it. Required for Remote Config
  // (Firebase Installations). The clothes catalog modal will surface a clear
  // error until this is set.
  appId: optionalEnv("VITE_FIREBASE_APP_ID"),
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const storage = getStorage(app);
